import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {SaveFormService} from "../services/save-form.service";

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {

  productList: ProductType[] = [
    {code: 'P2P', name: 'PRODUCTS_PAGE.TYPE-1'},
    {code: 'PAYMENT', name: 'PRODUCTS_PAGE.TYPE-2'},
    {code: 'REFUND', name: 'PRODUCTS_PAGE.TYPE-3'},
    {code: 'CARDS_TOKENIZATION', name: 'PRODUCTS_PAGE.TYPE-4'},
    {code: 'PAYMENT_LINK', name: 'PRODUCTS_PAGE.TYPE-5'},
    {code: 'PAYMENT_QR', name: 'PRODUCTS_PAGE.TYPE-6'},
    {code: 'RECURRING_PAYMENT', name: 'PRODUCTS_PAGE.TYPE-7'},
  ]

  selectedProductList: string[] = []

  constructor(
    private router: Router,
    private saveFormService: SaveFormService
  ) {
  }


  ngOnInit() {
    this.initForm()
  }

  initForm() {
    if (localStorage.hasOwnProperty('form')) {
      if (this.saveFormService.getFormData().products.productList) {
        this.selectedProductList = this.saveFormService.getFormData().products.productList.split(',')
      }
    } else {
      this.saveFormService.initFormLocalStorage()
    }
  }

  selectProduct(code: string) {
    if (this.selectedProductList.includes(code)) {
      this.selectedProductList.splice(this.selectedProductList.indexOf(code), 1)
    } else {
      this.selectedProductList.push(code)
    }

    this.saveFormService.saveProducts(this.selectedProductList.join(','))
  }

  sendForm() {
    this.router.navigate(['/register/agreement'])
  }

}
